var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-container",
    [
      _c(
        "v-row",
        [
          _c(
            "v-col",
            { staticClass: "pb-0", attrs: { cols: "12" } },
            [
              _vm.successMessage
                ? _c(
                    "v-alert",
                    {
                      staticClass: "mt-2",
                      attrs: { type: "success", dismissible: "" }
                    },
                    [
                      _c("span", { staticClass: "text-uppercase" }, [
                        _vm._v(_vm._s(_vm.successMessage))
                      ])
                    ]
                  )
                : _vm._e(),
              _vm._l(_vm.errorMessages, function(item, index) {
                return _c(
                  "v-alert",
                  {
                    key: index,
                    staticClass: "mt-2",
                    attrs: { type: "error", dismissible: "" }
                  },
                  [
                    _c("span", { staticClass: "text-uppercase" }, [
                      _vm._v(_vm._s(item.first()))
                    ])
                  ]
                )
              })
            ],
            2
          ),
          _c(
            "v-col",
            { staticClass: "pt-0", attrs: { cols: "4" } },
            [
              _c("router-view", {
                attrs: { details: _vm.stockFeedDetail },
                on: {
                  success: _vm.initSuccessMessage,
                  error: _vm.initErrorMessage,
                  reset: _vm.resetMessages
                }
              })
            ],
            1
          ),
          _c(
            "v-col",
            { staticClass: "pt-0", attrs: { cols: "8" } },
            [
              _c("table-stock-feed-detail", {
                on: {
                  "edit-item": item => {
                    _vm.stockFeedDetail = item
                  }
                }
              })
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }